<div [id]="iframe ? null : id" class="payment-integration-field">
    <iframe [id]="id" *ngIf="iframe"></iframe>
</div>
<mat-spinner *ngIf="!loaded" [diameter]="fieldMinSize" color="accent"></mat-spinner>